<template>
    <div style="width: 1000px;min-height:100vh;display: flex;justify-content: center;align-items: center;margin: 0 auto;">
        <div style="margin-top: 120px;">
            <div style="width: 1000px;height:700px;background: #FFFFFF">
                <div style="clear: both;display: flex;align-items: center;padding-top: 60px;">
                    <div style="font-size: 25px;color:#444444;font-weight:bold;display: flex;justify-content: center;flex: 1;">请假申请表</div>
                </div>
                <div style="clear: both;padding-top: 30px;">
                    <div style="width: 920px;height: 10px;background: #FF9800;border-radius: 20px 20px 0px 0px;margin: 0 auto;"></div>
                    <div class="gradient-border" style="width: 916px;min-height: 450px;clear: both;margin: 0 auto;box-shadow: 0px 2px 6px 1px rgba(0,0,0,0.16);">
                        <teble style="width: 100%;font-size: 14px;">
                            <tr class="typeface">
                                <th style=" width: 100px;height: 20px;padding: 23px 42.5px;font-size: 17px; color: #444444;border-left:1px solid #808080;border-right:1px solid #CFCFCF;font-weight: bold;border-bottom:1px solid #CFCFCF;border-left: none">姓名</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">{{content.fd_1703474114910}}</td>
                                <th style=" width: 100px;height: 20px;padding: 23px 41px;font-size: 17px; color: #444444;font-weight: bold;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">部门</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #808080;border-right: none">{{content.fd_1703474116744}}</td>
                            </tr>
                        </teble>
                        <table border="1" style="width: 100%;height: 200px;overflow: hidden;font-size: 14px;border: none">
                            <tr class="typeface">
                                <th class="title">请假类别</th>
                                <td class="content" >
                                    <el-radio-group v-model="type" style="line-height: 20px;" :disabled="type != content.fd_1703474133694">
                                        <el-radio :label="1">调休</el-radio>
                                        <el-radio :label="2">事假</el-radio>
                                        <el-radio :label="3">病假</el-radio>
                                        <el-radio :label="4">丧假</el-radio>
                                        <el-radio :label="5">婚假</el-radio>
                                        <el-radio :label="6">产假</el-radio>
                                        <el-radio :label="7">看护假</el-radio>
                                        <el-radio :label="8">工伤假</el-radio>
                                        <el-radio :label="9">年假</el-radio>
                                        <el-radio :label="10">其它</el-radio>
                                    </el-radio-group>
                                </td>
                            </tr>
                            <tr class="typeface">
                                <th class="title">请假事由</th>
                                <td class="content">{{content.fd_1677729356192}}</td>
                            </tr>
                            <tr class="typeface" style="border-bottom: none">
                                <th class="title">请假时间</th>
                                <td class="content"><div style="float: left;" v-for="(item,index) in content.fd_1703474243795" :key="index" :style="index == 1?'margin-left: 10px':''">{{item}} <span style="padding: 0 10px;" v-if="index !== content.fd_1703474243795.length - 1">至</span></div></td>
                            </tr>
                        </table>
                        <teble style="width: 100%;font-size: 14px;">
                            <tr class="typeface">
                                <th style=" width: 100px;height: 20px;padding: 23px 42.5px;font-size: 17px; color: #444444;border-left:1px solid #808080;border-right:1px solid #CFCFCF;font-weight: bold;border-bottom:1px solid #CFCFCF;border-left: none">请假时长</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">{{content.fd_1703495445640}}</td>
                                <th style=" width: 100px;height: 20px;padding: 23px 41px;font-size: 17px; color: #444444;font-weight: bold;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">销假日期</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #808080;border-right: none">{{content.fd_1703474387196}}</td>
                            </tr>
                        </teble>
                        <teble style="width: 100%;font-size: 14px;">
                            <tr class="typeface">
                                <th style=" width: 149px;height: 20px;padding: 23px 18.5px;font-size: 17px; color: #444444;border-left:1px solid #808080;border-right:1px solid #CFCFCF;font-weight: bold;border-bottom:1px solid #CFCFCF;border-left: none">部门负责人签字</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">{{content.fd_1703497253893}}</td>
                                <th style=" width: 145px;height: 20px;padding: 23px 18.5px;font-size: 17px; color: #444444;font-weight: bold;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #CFCFCF;">项目负责人签字</th>
                                <td style=" width: 260px;font-size: 17px;height: 20px;color: #444444;padding: 10px;border-left: none;border-bottom:1px solid #CFCFCF;border-top: none;border-right:1px solid #808080;border-right: none">{{content.fd_1703474409849}}</td>
                            </tr>
                        </teble>
                        <table border="1" style="width: 100%;height: 50px;overflow: hidden;font-size: 14px;border: none;">
                            <tr class="typeface">
                                <td class="title" style="border-bottom: none;border-right: none;">说明：本表为一人一事一时一表，多填无效，签批完成报人事存档。</td>
                            </tr>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {

    },

    computed: {

    },
    data () {
        return {
            type: 1,
            content: {}
        }
    },
    mounted:function(){
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        this.getRoomContent()
    },

    methods:{
        // 获取内容
        getRoomContent() {
            this.newApi.getRoomContentInfo({id: this.$route.params.id}).then(res =>{
                this.content = res.data.content;
                this.radiogo = res.data.content.fd_1702965880225
                this.radiocircle = res.data.content.fd_1702966153115
            })
        },

    }
}
</script>
<style scoped>
.title {
    width: 100px;
    height: 20px;
    padding: 23px 26px;
    font-size: 17px;
    color: #444444;
    border-bottom:1px solid #CFCFCF;
    font-weight: bold;
    border-right:1px solid #CFCFCF;
    border-left: none;
    border-top: none;
    font-family:'SimHei';

}
.content {
    font-size: 17px;
    height: 20px;
    color: #444444;
    width: 80%;
    border-bottom:1px solid #CFCFCF;
    border-top: none;
    border-left: none;
    border-right: none;
    padding: 10px;
}
/deep/ .el-radio__inner {
    width: 17px;
    height: 17px;
}
/deep/ .el-radio__inner::after {
    width: 7px;
    height: 7px;
    left: 51%;
    top: 54%;
}
/deep/ .el-radio__label {
    font-size: 15px;
}

.gradient-border {
    border-right: 2px solid #ddd;
    border-left: 2px solid #ddd;
    border-image: linear-gradient(rgb(255, 152, 0), #FFFFFF) 30 30;
}
</style>